import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SensorsComponent } from '@uigy/modules/sensors/components/sensors/sensors.component';
import { SensorsRouterModule } from '@uigy/modules/sensors/sensors-router-module';
import { NotificationComponent } from '@uigy/shared/components/info/notification.component';

import { ToggleBoxComponent } from '@uigy/shared/components/toggle-box/toggle-box.component';
import { ToggleFormComponent } from '@uigy/shared/components/toggle-form/toggle-form.component';
import { ValidationMessageComponent } from '@uigy/shared/components/validation-message/validation-message.component';
import { UIButtonComponent } from '@uigy/shared/components/ui-button/ui-button.component';
import { UiGridComponent } from '@uigy/shared/components/ui-grid/components/ui-grid/ui-grid.component';
import { EditSensorComponent } from './components/edit-sensor/edit-sensor.component';


@NgModule({
  declarations: [
    SensorsComponent,
    EditSensorComponent,
  ],
  providers: [
    DatePipe,
  ],
  exports: [
    SensorsComponent,
  ],
  imports: [
    CommonModule,
    SensorsRouterModule,

    UiGridComponent,
    ToggleBoxComponent,
    ToggleFormComponent,
    NotificationComponent,
    ValidationMessageComponent,
    UIButtonComponent,
    ReactiveFormsModule,
  ],
})
export class SensorsModule {
}
